import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Search: React.FC<IconProps> = ({
                                                  fill = COLORS.FG.SOFT,
                                                  width = 24,
                                                  height = 24,
                                                  className,
                                              }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Action / Search" width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M17.5 11C17.5 14.5899 14.5899 17.5 11 17.5C7.41015 17.5 4.5 14.5899 4.5 11C4.5 7.41015 7.41015 4.5 11 4.5C14.5899 4.5 17.5 7.41015 17.5 11ZM16.1018 17.1624C14.717 18.3101 12.9391 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 12.9391 18.3101 14.717 17.1624 16.1018L20.9991 19.9384L19.9384 20.9991L16.1018 17.1624Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
